export default function (lineCurrency) {
    return lineCurrency === 'EUR' ? ' €' : lineCurrency;
}



// WEBPACK FOOTER //
// ./src/utils/getCurrency.js